export default {
    o_item_status: "狀態",
   
    o_item_borrowing_amount: "應還金額",
    o_item_borrowing_principal: "目前應還",
    o_item_borrowing_principal2: "待還金額",
    o_item_daily_interest: "利息",
    o_item_service_fee: "服務費",
    o_item_borrowing_cycle: "借款週期",
    o_item_borrowing_time: "放款時間",
    o_item_application_time: "借款時間",
    o_item_expire_date: "到期時間",
    o_item_expire_dead_date: "還款截止時間",
    o_item_days_overdue: "逾期天數",
    o_item_overdue_fee: "逾期費用",
    o_item_lagfall_fee: "滯納金",
    o_item_clarify_time: "結清時間",
    o_item_total_repayment_amount: "到期應還金額",
    o_item_income: "收款人",
    o_item_receiving_account: "收款帳戶/帳號",
    o_item_changeAccount: "更改賬戶",
    o_item_beneficiary_bank: "收款銀行",

    o_item_receive_loan: "領取貸款",
    o_item_receive_loan_again: "再藉一筆",
    o_item_repay_loan: "還款",
    o_item_produce: "聯絡客服",
    o_item_popup_cancel: "取消",
    o_item_popup_confirm: "確定",
    o_item_toast_msg: "該產品已下線，請嘗試其他產品",
    o_item_loan_money: "貸款金額",
    o_item_repay_money: "還款金額",
    o_item_dispose_time: "處理時間",
    o_item_cut_off_time: "還款截止日期",
    o_item_finish_time: "訂單完成時間",
    o_list_nav_bar: "訂單",
    o_list_audit_result: "審核結果",
    o_list_for_reimbursement: "待還款",
    o_list_for_clarify: "已結清",
    o_list_payment_successful: "還款成功",
    o_list_to_borrow_a_pen: "去借一筆",
    o_details_nav_title: "訂單詳情",
    o_details_repayment: "應還總金額",
    o_details_amount_to_be_also: "待還總金額",
    o_details_due_date: "還款日",
    o_details_overdue: "已逾期",
    o_details_distance_due_date: "距離還款日",
    o_details_unit_day: "天",
    o_details_application_time: "處理日期",
    o_details_timely_time: "還款截止日期",
    o_details_applied_amount: "申請金額",
    o_details_application_period: "申請期間(天)",
    o_details_payment_amount_due: "到期應還金額",
    o_details_demurrage: "逾期費",
    o_details_submit_btn: "還款",
    o_details_rollver_submit_btn: "展期",
    o_select_back_method: "選擇還款方式",
    o_none_again_order: "暫無訂單，馬上去借一筆吧！",
    o_none_order_record: "無訂單記錄",
    o_go_loan: "去借款",
    o_current_state: "目前狀態",
    o_check_details: "詳情",
    o_click_withdrawal: "領取金額",
    o_apply_again: "再次申請",
    o_click_repay: "點擊還款",
    o_loan_nav_title: "確認借款",
    o_loan_loan_amounts: "借款金額",
    o_loan_repay_amount: "已還金額",
    o_loan_maximum_borrowing: "最高金額",
    o_loan_please_try_after: "請於$1後再試",
    o_loan_to_the_account_amounts: "到帳金額",
    o_loan_bank_account_or_cardnum: "銀行帳號/卡號",
    o_loan_loan_time_init_day: "借款期限（天）",
    o_loan_schedule_the_repayment_date: "計畫還款日",
    o_loan_msg: "到帳金額與還款日以最終核准結果為準",
    o_loan_submit_btn: "領取貸款",
    o_loan_submit_success: "領取成功",
    o_list_pulling_text: "下拉即可刷新...",
    o_list_loosing_text: "釋放即可刷新...",
    o_list_loading_text: "載入中...",
    o_before_loan_detail_tips_title: "注意：",
    o_before_loan_detail_tips_2: "當您同意確認借款後，若審核通過，金額會直接到帳您的銀行帳號/卡號中",
    o_before_loan_detail_tips_3: "當您未操作確認借款，若審核通過，您也可透過手動領取貸款，取得您的貸款",
    o_btn_reject: "拒絕",
    o_before_loan_detail_pop_content: "是否確認核准通過後，金額直接到帳您的銀行帳號/卡號？"
}